import React, {useState} from 'react'
import {Button, Modal} from "antd";
import {deleteEmployee} from "../../services/serviceEmployee";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const EmployeeDelete = ({employeeId, updater}) => {
    const [deleteModal, setDeleteModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleDeleteClick = (decision) => {
        if (decision) {
            enterLoadingState(setLoadings)
            deleteEmployee(employeeId)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setDeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        } else {
            setDeleteModal(!deleteModal)
        }
    }

    return (
        <React.Fragment>
            <Button type={'link'} danger onClick={() => setDeleteModal(!deleteModal)}> Sil </Button>

            <Modal
                open={deleteModal}
                onCancel={() => setDeleteModal(!deleteModal)}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button danger type={'primary'} loading={loadings[0]} key={'submitButton'} onClick={() => handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>
        </React.Fragment>
    )
}
export default EmployeeDelete